import { useBlockRenderContext } from '@/components/blocks'
import type { BlockVisualProps } from '../../Types'
import type { HeaderBlock } from '@/types/blocks/document/Header'
import './header-visual.css'

export function HeaderVisual({ block }: BlockVisualProps) {
	const { mode } = useBlockRenderContext()

	if (block.type !== 'header') return null

	const headerBlock = block as HeaderBlock
	const { level, text } = headerBlock.properties

	// Mode-dependent empty state
	if (!text || text.trim() === '') {
		if (mode === 'editor') {
			return <div className="header-visual header-visual--empty">Empty header</div>
		}
		return null
	}

	// Dynamic heading tag
	const HeadingTag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

	return (
		<HeadingTag
			className={`header-visual header-visual--level-${level}`}
			data-block-id={headerBlock.id}
		>
			{text}
		</HeadingTag>
	)
}
